import React from 'react';

const Body = () => (
    <>
        <div className="aboutTopPad"></div>Sorry, the page you are looking for does not exist on
        this website. You may have followed an outdated link or typed the URL incorrectly.
        <br />
        <br />
        You could try one of these options:
        <ul className="list">
            <li>Check your URL and try again</li>
            <li>
                Return to the{' '}
                <a href="/" className="link" title="Home Page">
                    home page
                </a>
            </li>
            <li>Search the website using the search facility in the main navigation</li>
        </ul>
        <br />
        If you would like to report a problem, please{' '}
        <a href="/contact-us" className="link" title="Contact us">
            contact us
        </a>
        .
    </>
);

export const content = {
    image: 'https://files.jdplc.com/images/about/privacy.jpg',
    body: Body,
};
